import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import "./Index.css";
import { MoneyFormat } from "../../../../../../utils/NumberUtil";
import { RoutePath } from "../../../../../../constants/RoutePath";
import ZoneTag from "../components/ZoneTag";
import { FuzzySearchType, TAGS_TYPE } from "../../../../Enums";
import heartPng from '../../../../../../images/mine/heart.png'
import heartOutLinePng from '../../../../../../images/mine/heartOutLine.png'


import LocationOnOutlined from '@material-ui/icons/LocationOnOutlined';
import { GPSMapUtils } from "../../../../../../utils/GPSMapUtils";
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import HttpUtils from '../../../../../../utils/HttpUtils';
import { cancelFavoriteApi } from '../../../../WebService';

const noImageUrl = require("../../../../../../images/照片采集中.png");

class SearchResultItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formatMessage: this.props.intl['formatMessage'],
        }
    }

    _handleOpenDetail(zone) {
        this.props.viewPositionFunction && this.props.viewPositionFunction.call();
        if (window.__wxjs_environment === 'miniprogram') {
            this._handleOpenLocation(zone)
            //    this.props.router.navigate(RoutePath.WMS_ZONE_DETAIL.path.replace(":id", zone.id));
        } else {
            this.props.router.navigate(RoutePath.WMS_ZONE_DETAIL.path.replace(":id", zone.zoneId));
        }
    }

    _handleOpenLocation(zone) {

        //携带参数进入小程序，使用小程序地图定位API
        //保存当前地址，以便从小程序中返回时使用
        let jumpUrl = window.location;
        let title = "详情"
        //传递多个参数时用&连接
        let path = '/modules/wms/views/zone/detail/index?id=${id}&title=' + title;
        path = path.replace("${id}", zone.zoneId);



        //使用navigateTo跳转到小程序路径中
        window.wx.miniProgram.navigateTo({
            url: path
        })
    }

    cancelCollect() {
        // 提示是否取消收藏
        Modal.confirm({
            title: '是否取消收藏',
            icon: <ExclamationCircleOutlined />,
            content: '',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                // 调用接口取消收藏
                HttpUtils.post(
                    cancelFavoriteApi,
                    {
                        zoneId: this.props.zone.zoneId
                    },
                    (res) => {
                        this.props.refreshList && this.props.refreshList()
                    }, () => {
                    }
                )
            }
        });
        // 调用接口取消收藏

    }

    render() {
        const zone = this.props.zone;
        const showCollect = this.props.showCollect;
        let imageUrl = zone.zonePhotos[0] ? zone.zonePhotos[0] + "?x-oss-process=style/Image_w260h220PNG" : noImageUrl;
        const items = [];
        if (zone.district) {
            items.push(zone.district);
        }
        if (zone.town) {
            items.push(zone.town);
        }
        let locationParts = null;
        let currentLocation = this.props.currentLocation;
        let searchCondition = this.props.searchCondition;

        if (searchCondition && searchCondition.searchFuzzyType === FuzzySearchType.Enums.Location) {
            let distance = GPSMapUtils.distance(searchCondition.rectangleCenterPointLat, searchCondition.rectangleCenterPointLng, zone.latitude, zone.longitude)
            locationParts =
                <div className="zone-image-foot-distance">{MoneyFormat.formatOne((distance) / 1000)}KM</div>

        }
        else if (currentLocation) {
            let distance = GPSMapUtils.distance(currentLocation.lat, currentLocation.lng, zone.latitude, zone.longitude)
            locationParts =
                <div className="zone-image-foot-distance">距您{MoneyFormat.formatOne((distance) / 1000)}KM</div>
        }
        let zoneName = zone.name;
        // if(zoneName.length>20){
        //     zoneName = zoneName.substr(0,20)+"...";
        // }
        return (
            <div key={zone.id} className="zone-item-box" onClick={() => this._handleOpenDetail(zone)}>

                <div className="zone-item">
                    <div className="zone-image-box">
                        <div className="zone-image-container">
                            <img className="zone-image" src={imageUrl} />
                            <div className="zone-image-header">
                                {
                                    showCollect && (
                                        <img src={heartPng} onClick={(e) => {
                                            e.stopPropagation();
                                            this.cancelCollect()
                                        }} />
                                    )
                                }
                                <p>#{zone.number}</p>
                            </div>
                            <div className="zone-image-foot">
                                <div className="zone-image-foot-location"><LocationOnOutlined /> {items.join("-")}</div>
                                {locationParts}
                            </div>
                        </div>
                    </div>
                    <div className="zone-content-box">
                        <div>
                            <div className="zone-content-title-box">
                                <div className="zone-content-title1">{zoneName}</div>

                                <div
                                    className="zone-content-title2">总建筑面积 {MoneyFormat.formatThreeByComma(zone.buildingArea)}m²
                                </div>
                            </div>
                            <div className="zone-content-rent-box">
                                <span className="zone-content-rent">{zone.rentShow}</span>
                                <span
                                    className="zone-content-rent-unit">{zone.rentShow === '面议' ? " " : "元/m²/天"}</span>
                                <div className="zone-content-rent-comment">预计有效租金-不含税含物业</div>
                            </div>


                            <div className="zone-content-vacant-box">
                                <div className="zone-content-vacant-item-box">
                                    <div>
                                        <span
                                            // className="zone-content-vacant-item-area">{MoneyFormat.formatThreeByComma(zone.vacantArea)} </span>
                                            // className="zone-content-vacant-item-area">{zone.vacantAreaMobileStr} </span>
                                            className="zone-content-vacant-item-area"> {zone.vacantAreaStr} </span>
                                        {/* <span
                                            className="zone-content-vacant-item-unit">m²</span> */}
                                    </div>

                                    <div className="zone-content-vacant-item-name">空置面积 m²</div>
                                </div>
                                {zone.subleaseArea > 0 ? <div className="zone-content-vacant-item-box">
                                    <div>
                                        <span
                                            className="zone-content-vacant-item-area">{MoneyFormat.formatThreeByComma(zone.subleaseArea)} </span>
                                        {/* <span
                                            className="zone-content-vacant-item-unit">m²</span> */}
                                        <div className="zone-content-vacant-item-name">可转租面积 m²</div>
                                    </div>

                                </div> : null}
                            </div>

                            <div className="zone-content-tag">
                                {zone.subleaseArea ? <ZoneTag text="部分面积可转租" color={"#c10001"} /> : null}
                                {
                                    zone && zone.tags && zone.tags.map((item, index) => {
                                        return <ZoneTag key={index} text={item} />
                                    })
                                }
                                {/* {
                                    zone.tagList ? zone.tagList.filter(item => TAGS_TYPE.Map[item]).map((item, index) => {
                                        if ((zone.subleaseArea && index >= 1) || index >= 3) {//超过三个就不显示了
                                            if (index === zone.tagList.length - 1) {
                                                return "...";
                                            } else {
                                                return null;
                                            }
                                        }
                                        return (
                                            <ZoneTag key={index} text={TAGS_TYPE.Map[item].label} />
                                        )
                                    }) : null
                                } */}
                            </div>

                            {/*<div className="zone-content-name">*/}
                            {/*<Flex>*/}

                            {/*<Flex.Item style={{flex: 1}}>*/}
                            {/*<span className="zone-content-rent-unit">¥&nbsp;</span>*/}
                            {/*<span*/}
                            {/*className="zone-content-rent">{MoneyFormat.formatTwo(zone.rentEffective)}&nbsp;</span>*/}
                            {/*<span className="zone-content-rent-unit">元/m²/天</span>*/}
                            {/*</Flex.Item>*/}
                            {/*</Flex>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

function mapStateToProps(store) {
    return {
        currentLocation: store.WMSZoneReducer.currentLocation,
        searchCondition: store.WMSZoneReducer.searchCondition,

    }
}

export default connect(mapStateToProps)(injectIntl(SearchResultItem));